<shared-spinner *ngIf="isLoading"></shared-spinner>

<div *ngIf="!isLoading"
     [style.height.px]="height"
     leaflet 
     [leafletOptions]="options"
     [leafletLayers]="layers">
</div>